import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { LegacyDevice } from 'console/device/device';
import { DeviceThermometersView } from '../thermometers-view';
export const ThermometersCard = React.memo(function ThermometersCard(props) {
    const { server_time, r_device } = props;
    const active_thermometers = LegacyDevice.active_thermometers(r_device.thermometers || []);
    if (active_thermometers.length <= 0)
        return null;
    return (_jsxs("div", { className: "ui-falarm-main-view-thermo ui-card ui-card-col-2 visible", children: [_jsx("h1", { children: "\u0422\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0430" }), _jsx(DeviceThermometersView, { r_device: r_device, server_time: server_time })] }));
});
